var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortAscend = function SvgSortAscend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit",
    clipPath: "url(#clip0_18645_181871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.39 17.35h-8.8c-.36 0-.59-.33-.59-.81s.24-.81.59-.81h8.8c.36 0 .59.33.59.81s-.24.81-.59.81M12.27 12.48H3.71c-.43 0-.71-.33-.71-.81s.29-.81.71-.81h8.56c.43 0 .71.33.71.81s-.29.81-.71.81M12.07 7.61H3.91c-.55 0-.91-.33-.91-.81s.37-.81.91-.81h8.16c.55 0 .91.33.91.81s-.37.81-.91.81M17.77 17.35c-.49 0-.81-.46-.81-1.13V7.13c-.01-.67.32-1.13.81-1.13s.81.46.81 1.13v9.08c-.01.68-.34 1.13-.81 1.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.19 10.05c-.24 0-.41-.08-.57-.24l-1.87-1.87-1.87 1.87c-.33.33-.81.33-1.13 0-.33-.33-.33-.81 0-1.13l2.44-2.43c.33-.33.81-.33 1.13 0l2.43 2.43c.33.33.33.81 0 1.13-.16.16-.33.24-.57.24z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18645_181871"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 17.35h18V6H3z"
  })))));
};
export default SvgSortAscend;